<template>
  <section class="friends py-12 my-16 px-md-10 px-4">
    <h2 class="friends__title">
      {{ friendsData.title }}
    </h2>
    <p v-html="friendsData.description" class="friends__text mt-8"></p>
    <div class="sponsors">
      <div class="sponsors__hr"></div>
      <h3 class="sponsors__title my-5">{{ friendsData.sponsorTitle }}:</h3>
      <v-row no-gutters class="sponsors__names align-center">
        <div
          class="sponsors__names"
          v-for="(sponsor, index) in friendsData.sponsors"
          :key="index"
        >
          <h3>{{ sponsor.name.split(" ")[0] }}</h3>
          <h3 style="color: #FFA903">
            {{
              sponsor.name
                .split(" ")
                .slice(1)
                .join(" ")
            }}
          </h3>
        </div>
      </v-row>
      <v-row class="partners__wrapper" v-if="$vuetify.breakpoint.mdAndUp">
        <v-col
          cols="3"
          v-for="(partner, index) in expandedSponsors"
          :key="index"
          class="partners__item"
        >
          <div class="partners__item-wrapper">
            <a target="_blank" :href="partner.link">
              <div class="partners__item-circle mb-8">
                <v-img :src="getPartnerImg(partner)" class="partners__item-img">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="#FFA903" />
                    </v-row>
                  </template>
                </v-img>
              </div>
            </a>
            <h5 class="partners__item-name">{{ partner.name }}</h5>
            <p class="partners__item-text my-4">{{ partner.description }}</p>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="partners">
      <div>
        <h3 class="sponsors_-title mb-5">{{ friendsData.partnersTitle }}:</h3>
        <v-row class="partners__wrapper" v-if="$vuetify.breakpoint.mdAndUp">
          <v-col
            cols="3"
            v-for="(partner, index) in partners"
            :key="index"
            class="partners__item"
          >
            <div class="partners__item-wrapper">
              <a target="_blank" :href="partner.link">
                <div class="partners__item-circle mb-8">
                  <v-img
                    :src="getPartnerImg(partner)"
                    class="partners__item-img"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="#FFA903" />
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </a>
              <h5 class="partners__item-name">{{ partner.name }}</h5>
              <p class="partners__item-text my-4">{{ partner.description }}</p>
            </div>
          </v-col>
        </v-row>
        <vue-slick-carousel
          class="lectorsSliderMobile"
          v-else
          v-bind="settings"
        >
          <div
            class="partners__mobile-item px-4"
            v-for="(partner, index) in partners"
            :key="index"
          >
            <div class="mx-auto partners__item-circle mb-8">
              <v-img
                :src="getPartnerImg(partner)"
                class="partners__item-img"
                contain
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="#FFA903" />
                  </v-row>
                </template>
              </v-img>
            </div>
            <h5 class="mx-auto text-center partners__item-name">
              {{ partner.name }}
            </h5>
            <p class="mx-auto text-center partners__item-text my-4">
              {{ partner.description }}
            </p>
          </div>
        </vue-slick-carousel>
      </div>
      <div class="mt-16 mt-sm-10">
        <h3 class="sponsors_titlemb-5 mb-5">
          {{ friendsData.infoPartnersTitle }}:
        </h3>
        <v-row class="partners__wrapper" v-if="$vuetify.breakpoint.mdAndUp">
          <v-col
            cols="3"
            v-for="(partner, index) in infoPartners"
            :key="index"
            class="partners__item"
          >
            <div class="partners__item-wrapper">
              <a target="_blank" :href="partner.link">
                <div class="partners__item-circle mb-8">
                  <v-img
                    :src="getPartnerImg(partner)"
                    class="partners__item-img"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="#FFA903" />
                      </v-row>
                    </template>
                  </v-img>
                </div>
              </a>
            </div>
          </v-col>
        </v-row>
        <vue-slick-carousel
          class="lectorsSliderMobile pt-6"
          v-else
          v-bind="settings"
        >
          <div
            class="partners__mobile-item px-4"
            v-for="(partner, index) in infoPartners"
            :key="index"
          >
            <div class="mx-auto partners__item-circle mb-8">
              <v-img
                :src="getPartnerImg(partner)"
                class="partners__item-img"
                contain
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="#FFA903" />
                  </v-row>
                </template>
              </v-img>
            </div>
          </div>
        </vue-slick-carousel>
      </div>
    </div>
  </section>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "Friends",
  components: {
    VueSlickCarousel
  },
  computed: {
    friendsData() {
      return this.$t("friends");
    },
    expandedSponsors() {
      return this.$t("friends").expandedSponsors;
    },
    partners() {
      return this.$t("friends").partners;
    },
    infoPartners() {
      return this.$t("friends").infoPartners;
    }
  },
  data: () => ({
    settings: {
      arrows: false,
      dots: true,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 300,
      draggable: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false
          }
        }
      ]
    }
  }),
  methods: {
    getPartnerImg(partner) {
      if (partner?.img) {
        return partner.img;
      }
      return partner?.localImg
        ? require(`@/assets/img/partners/${partner?.localImg}`)
        : "";
    }
  }
};
</script>

<style lang="sass" scoped>
@import "./src/assets/style/vars"

.friends
  color: $dark

.sponsors
  margin-top: 4.5rem
  &__hr
    width: 60px
    height: 3px
    background-color: #FFA903
  &__names
    margin-right: 90px
    margin-bottom: 20px

.partners
  margin-top: 4.5rem
  &__item
    font-size: 16px !important
    &-wrapper
      width: 14rem !important
    &-circle
      width: 228px
      height: 228px
      border-radius: 50%
      display: flex
      align-items: center
      justify-content: center
      overflow: hidden
    &-name
      font-size: 16px !important
</style>

<style lang="scss">
.lectorsSliderMobile {
  position: relative;

  .slick-dots {
    position: absolute;
    bottom: -2rem;
    left: 50%;
    transform: translateX(-50%);

    li button {
      &::before {
        content: "";
        width: 0.5rem !important;
        height: 0.5rem !important;
        background-color: #2f2e43;
        border-radius: 50%;
        display: block;
      }
    }
  }
}
</style>
